import React from "react";
import { scaleLinear } from "d3-scale";
import { extent } from "d3-array";

const EductionSpendingChart = ({ props }) => {
  const width = props.width;
  const height = props.height + 20;

  const margin = {
    top: 50,
    right: 50,
    bottom: 70,
    left: 40,
  };

  const w = width - margin.right - margin.left;
  const h = height - margin.top - margin.bottom;

  const data = props.data.educationSpending;

  const y = scaleLinear()
    .domain(extent(data.map((d) => [d.low, d.average, d.high]).flat()))
    .range([h, 0]);

  return (
    <div>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <defs>
          <linearGradient
            id="gradient-up-green"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop
              offset="0%"
              style={{
                stopColor: "rgba(255, 255, 255, 0.3)",
              }}
            />
            <stop
              offset="100%"
              style={{
                stopColor: "green",
                stopOpacity: 0.3,
              }}
            />
          </linearGradient>
          <linearGradient
            id="gradient-down-green"
            x1="0%"
            y1="100%"
            x2="0%"
            y2="0%"
          >
            <stop
              offset="0%"
              style={{
                stopColor: "rgba(255, 255, 255, 0.3)",
              }}
            />
            <stop
              offset="100%"
              style={{
                stopColor: "green",
                stopOpacity: 0.3,
              }}
            />
          </linearGradient>
          <linearGradient
            id="gradient-up-blue"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop
              offset="0%"
              style={{
                stopColor: "rgba(255, 255, 255, 0.3)",
              }}
            />
            <stop
              offset="100%"
              style={{
                stopColor: "steelblue",
                stopOpacity: 0.3,
              }}
            />
          </linearGradient>
          <linearGradient
            id="gradient-down-blue"
            x1="0%"
            y1="100%"
            x2="0%"
            y2="0%"
          >
            <stop
              offset="0%"
              style={{
                stopColor: "rgba(255, 255, 255, 0.3)",
              }}
            />
            <stop
              offset="100%"
              style={{
                stopColor: "steelblue",
                stopOpacity: 0.3,
              }}
            />
          </linearGradient>
        </defs>
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <g className="y-axis">
            {y.ticks(10).map((d) => (
              <g key={`y-tick-${d}`} transform={`translate(0, ${y(d)})`}>
                <line
                  x1={0}
                  x2={0}
                  stroke="#ccc"
                  style={{ strokeWidth: 0.5 }}
                />
                <text
                  dx={-5}
                  style={{
                    fontSize: "12px",
                    textAnchor: "end",
                    dominantBaseline: "central",
                  }}
                >
                  {d}%
                </text>
              </g>
            ))}
            <line x2={width} y1={y(0)} y2={y(0)} stroke="#ccc" />
          </g>
          <g>
            {data
              .filter((d) => d.type === "International remittances")
              .map((d, i) => (
                <g
                  key={`datum-${i}`}
                  transform={`translate(${20 + i * (w < 500 ? 40 : 50)}, 0)`}
                >
                  <rect
                    y={y(d.high)}
                    width={30}
                    height={y(d.average) - y(d.high)}
                    fill="url(#gradient-up-green)"
                  />
                  <rect
                    y={y(d.average)}
                    width={30}
                    height={y(d.low) - y(d.average)}
                    fill="url(#gradient-down-green)"
                  />
                  <line
                    x1={15}
                    x2={15}
                    y1={y(0)}
                    y2={y(d.average)}
                    stroke="green"
                    style={{
                      strokeWidth: 3,
                      strokeLinecap: "round",
                    }}
                  />
                  <line
                    x1={15}
                    x2={15 + 3}
                    y1={y(d.average)}
                    y2={y(d.average) + (d.average < 0 ? -10 : 10)}
                    stroke="green"
                    style={{
                      strokeWidth: 3,
                      strokeLinecap: "round",
                    }}
                  />
                  <line
                    x1={15}
                    x2={15 - 3}
                    y1={y(d.average)}
                    y2={y(d.average) + (d.average < 0 ? -10 : 10)}
                    stroke="green"
                    style={{
                      strokeWidth: 3,
                      strokeLinecap: "round",
                    }}
                  />
                  <text
                    dx={15}
                    dy={d.average < 0 ? 8 : -8}
                    y={y(d.average)}
                    fill="white"
                    stroke="white"
                    style={{
                      fontSize: 11,
                      fontWeight: "bold",
                      textAnchor: "middle",
                      dominantBaseline: "central",
                    }}
                  >
                    <tspan style={{ fontWeight: "normal", fontSize: 10 }}>
                      avg.
                    </tspan>{" "}
                    {d.average > 0 ? "+" : ""}
                    {d.average}%
                  </text>
                  <text
                    dx={15}
                    dy={d.average < 0 ? 8 : -8}
                    y={y(d.average)}
                    fill="green"
                    style={{
                      fontSize: 11,
                      fontWeight: "bold",
                      textAnchor: "middle",
                      dominantBaseline: "central",
                    }}
                  >
                    <tspan style={{ fontWeight: "normal", fontSize: 10 }}>
                      {props.avg}
                    </tspan>{" "}
                    {d.average > 0 ? "+" : ""}
                    {d.average}%
                  </text>
                  <text style={{ fontSize: 12 }}>
                    {props[d.region].split(" ").map((d, i) => (
                      <tspan
                        key={`label-${i}`}
                        style={{ textAnchor: "middle" }}
                        x={15}
                        y={y(-30) + i * 12}
                      >
                        {d}
                      </tspan>
                    ))}
                  </text>
                </g>
              ))}
            <text
              style={{ fontSize: 12, textAnchor: "middle", fontWeight: "bold" }}
              y={y(-45)}
              dy={-5}
              fill="green"
            >
              <tspan x={1.5 * (w < 500 ? 40 : 50) + 15}>
                {props.international}
              </tspan>
              <tspan x={1.5 * (w < 500 ? 40 : 50) + 15} dy={14}>
                {props.remittances}
              </tspan>
            </text>
          </g>
          <g transform={`translate(${w / 2}, 0)`}>
            {data
              .filter((d) => d.type === "Internal remittances")
              .map((d, i) => (
                <g
                  key={`datum-${i}`}
                  transform={`translate(${60 + i * (w < 500 ? 40 : 50)}, 0)`}
                >
                  <rect
                    y={y(d.high)}
                    width={30}
                    height={y(d.average) - y(d.high)}
                    fill="url(#gradient-up-blue)"
                  />
                  <rect
                    y={y(d.average)}
                    width={30}
                    height={y(d.low) - y(d.average)}
                    fill="url(#gradient-down-blue)"
                  />
                  <line
                    x1={15}
                    x2={15}
                    y1={y(0)}
                    y2={y(d.average)}
                    stroke="steelblue"
                    style={{
                      strokeWidth: 3,
                      strokeLinecap: "round",
                    }}
                  />
                  <line
                    x1={15}
                    x2={15 + 3}
                    y1={y(d.average)}
                    y2={y(d.average) + (d.average < 0 ? -10 : 10)}
                    stroke="steelblue"
                    style={{
                      strokeWidth: 3,
                      strokeLinecap: "round",
                    }}
                  />
                  <line
                    x1={15}
                    x2={15 - 3}
                    y1={y(d.average)}
                    y2={y(d.average) + (d.average < 0 ? -10 : 10)}
                    stroke="steelblue"
                    style={{
                      strokeWidth: 3,
                      strokeLinecap: "round",
                    }}
                  />
                  <text
                    dx={15}
                    dy={d.average < 0 ? 8 : -8}
                    y={y(d.average)}
                    fill="white"
                    stroke="white"
                    style={{
                      fontSize: 11,
                      fontWeight: "bold",
                      textAnchor: "middle",
                      dominantBaseline: "central",
                    }}
                  >
                    <tspan style={{ fontWeight: "normal", fontSize: 10 }}>
                      {props.average}
                    </tspan>{" "}
                    {d.average > 0 ? "+" : ""}
                    {d.average}%
                  </text>
                  <text
                    dx={15}
                    dy={d.average < 0 ? 8 : -8}
                    y={y(d.average)}
                    fill="steelblue"
                    style={{
                      fontSize: 11,
                      fontWeight: "bold",
                      textAnchor: "middle",
                      dominantBaseline: "central",
                    }}
                  >
                    <tspan style={{ fontWeight: "normal", fontSize: 10 }}>
                      {props.average}
                    </tspan>{" "}
                    {d.average > 0 ? "+" : ""}
                    {d.average}%
                  </text>
                  <text style={{ fontSize: 12 }}>
                    {props[d.region].split(" ").map((d, i) => (
                      <tspan
                        key={`label-${i}`}
                        style={{ textAnchor: "middle" }}
                        x={15}
                        y={y(-30) + i * 12}
                      >
                        {d}
                      </tspan>
                    ))}
                  </text>
                </g>
              ))}
            <text
              style={{ fontSize: 12, textAnchor: "middle", fontWeight: "bold" }}
              y={y(-45)}
              dy={-5}
              fill="steelblue"
            >
              <tspan x={1.5 * (w < 500 ? 40 : 50) + 50}>{props.internal}</tspan>
              <tspan x={1.5 * (w < 500 ? 40 : 50) + 50} dy={14}>
                {props.remittances}
              </tspan>
            </text>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default EductionSpendingChart;
